import styled from 'styled-components'

import Link from '../Link'

import { formatAddress } from '../../helpers'

const Address = styled(Link).attrs(({ address }) => ({
  href: `https://www.google.com/maps/place/${formatAddress(address)}`,
  children: formatAddress(address),
  target: '_blank',
  trackingData: {
    event: 'Open Google Map',
  },
}))`
  padding: 0;
  color: ${props => props.theme.colors.black};
  margin-bottom: 0.48333rem;
`

export default Address
